var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70706 6.29297L8.29285 7.70718L12.5857 12.0001L8.29285 16.293L9.70706 17.7072L15.4142 12.0001L9.70706 6.29297Z",
    transform: "rotate(90 12 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionArrowDown);
export default __webpack_public_path__ + "static/media/ic_action_arrow_down.f3e80eab54b1b3ca68d20822df33d362.svg";
export { ForwardRef as ReactComponent };